import { render, staticRenderFns } from "./RolesBox.vue?vue&type=template&id=18646dbe&scoped=true&"
import script from "./RolesBox.vue?vue&type=script&lang=js&"
export * from "./RolesBox.vue?vue&type=script&lang=js&"
import style0 from "./RolesBox.vue?vue&type=style&index=0&id=18646dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18646dbe",
  null
  
)

export default component.exports